import React from "react";
import Layout from "components/layout";
import SEO from "components/seo";
import LanguageTranslationService from "components/languageTranslationService";

function SupportedLanguages() {
  const slug = "/language-translation-service.php";
  return (
    <Layout>
      <SEO slug={slug} />
      <LanguageTranslationService />
    </Layout>
  );
}

export default SupportedLanguages;
